// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Cyprus */
const CY = /^(?:9(?:10|[4-79]\d)\d{5})$/;

export default CY;
